import { TimelineStep } from '../../UI/Atoms/BeeTimeline';
import {
  LEISTUNGSART,
  NAMING_LS_IN_MARKTGEBIET,
  NAMING_SUSTAINABILITY_FACTOR
} from '../Statics/Constants';
import _ from 'lodash';

////////////
// HELPER //
////////////

export function isKeyPriceValidUntilKey(key: string) {
  return key.startsWith('valid_until_');
}

export function generatePriceValidUntilKey(phaseId: string) {
  return 'valid_until_' + phaseId;
}

export function isKeyUserEpMapKey(key: string) {
  return key.startsWith('user_ep_map_');
}

export function generateUserEpMapKey(phaseId: string, epcode: string) {
  return 'user_ep_map_' + simpleGenerateEpEntryId(phaseId, epcode);
}

export function generateBlFactorId(
  phase: TimelineStep,
  regionId: String,
  leistung: LEISTUNGSART
) {
  return simpleGenerateBlFactorId(phase.id, regionId, leistung.id);
}

export function simpleGenerateBlFactorId(
  phaseId: String,
  regionId: String,
  leistungssliceId: String
) {
  return phaseId + '_' + regionId + '_' + leistungssliceId;
}

export function simpleGenerateLsFactorId(
  phaseId: String,
  propertyId: String,
  sustainabilityFactor: boolean,
  leistungssliceId: String
) {
  if (sustainabilityFactor) {
    return (
      phaseId +
      '_' +
      propertyId +
      '_' +
      leistungssliceId +
      '_' +
      NAMING_SUSTAINABILITY_FACTOR
    );
  }
  return phaseId + '_' + propertyId + '_' + leistungssliceId;
}

export function simpleGenerateLsInMarktgebietId(
  phaseId: String,
  propertyId: string
) {
  return phaseId + '_' + propertyId + NAMING_LS_IN_MARKTGEBIET;
}

export function generateEpEntryId(phase: TimelineStep, epCode: string) {
  return simpleGenerateEpEntryId(phase.id, epCode);
}

export function simpleGenerateEpEntryId(phaseId: String, epCode: string) {
  return phaseId + '_' + epCode;
}

export function generateAlphaFilterId(phaseId: string) {
  return phaseId + '_filter';
}

export function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
